import { Component, input, ChangeDetectionStrategy, ViewEncapsulation, forwardRef, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgentChatInput } from "./ai-chat-input";
import { AgentChatViewDisclaimer } from "./ai-chat-view-disclaimer";
import { cn } from "../utils/utils";

@Component({
  standalone: true,
  selector: "agent-chat-view-input-container",
  imports: [CommonModule, AgentChatInput, AgentChatViewDisclaimer],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: ElementRef,
      useExisting: forwardRef(() => AgentChatViewInputContainer),
    },
  ],
  template: `
    <div [class]="computedClass">
      <!-- Input component -->
      <div class="achat-input-container__inner">
        <agent-chat-input></agent-chat-input>
      </div>

      <!-- Disclaimer -->
      <agent-chat-view-disclaimer></agent-chat-view-disclaimer>
    </div>
  `,
})
export class AgentChatViewInputContainer extends ElementRef {
  inputContainerClass = input<string | undefined>();

  constructor(elementRef: ElementRef) {
    super(elementRef.nativeElement);
  }

  get computedClass(): string {
    return cn("achat-input-container", this.inputContainerClass());
  }
}
